import React, { useEffect, useState } from 'react'
import { useAuth } from '../../auth/AuthContext'

const COMPETENCIES = ['leadership', 'problem-solving', 'conflict', 'teamwork', 'initiative', 'communication', 'technical', 'delivery', 'growth']

export function StoryBank() {
  const { token } = useAuth()
  const [stories, setStories] = useState([])
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState('')
  const [expanded, setExpanded] = useState(null)

  useEffect(() => {
    if (!token) return
    setLoading(true)
    fetch('/api/ark/stories', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : [])
      .then(setStories)
      .catch(() => {})
      .finally(() => setLoading(false))
  }, [token])

  const deleteStory = async (id) => {
    if (!token) return
    await fetch(`/api/ark/stories/${id}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    })
    setStories(s => s.filter(x => x.id !== id))
  }

  const filtered = filter
    ? stories.filter(s => (s.competency_tags || []).includes(filter))
    : stories

  if (!token) {
    return (
      <div className="ark-home-empty" style={{ padding: 40 }}>
        <a href="/account" className="ark-home-link">Sign in</a> to view your STAR Story Bank.
      </div>
    )
  }

  return (
    <div className="ark-storybank">
      <div className="ark-storybank-header">
        <h2 className="ark-home-section-title">STAR Story Bank</h2>
        <span className="ark-home-section-count">{stories.length}</span>
      </div>
      <p className="ark-pipeline-hint">
        Stories accumulated from evaluations. Use these to answer any behavioral question.
      </p>

      {/* Filter by competency */}
      <div className="ark-storybank-filters">
        <button
          className={`ark-storybank-filter-btn ${!filter ? 'active' : ''}`}
          onClick={() => setFilter('')}
        >All</button>
        {COMPETENCIES.map(c => (
          <button
            key={c}
            className={`ark-storybank-filter-btn ${filter === c ? 'active' : ''}`}
            onClick={() => setFilter(f => f === c ? '' : c)}
          >{c}</button>
        ))}
      </div>

      {loading ? (
        <div className="ark-home-empty">Loading…</div>
      ) : filtered.length === 0 ? (
        <div className="ark-home-empty">
          No stories yet. Run an evaluation and click "Save to Story Bank".
        </div>
      ) : (
        <div className="ark-storybank-list">
          {filtered.map(story => (
            <div key={story.id} className="ark-storybank-card">
              <div className="ark-storybank-card-header" onClick={() => setExpanded(e => e === story.id ? null : story.id)}>
                <div>
                  <div className="ark-storybank-title">{story.title}</div>
                  <div className="ark-storybank-tags">
                    {(story.competency_tags || []).map(t => (
                      <span key={t} className="ark-eval-tag">{t}</span>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <span className="ark-storybank-chevron">{expanded === story.id ? '▲' : '▼'}</span>
                  <button className="ark-queue-remove-btn" onClick={e => { e.stopPropagation(); deleteStory(story.id) }}>×</button>
                </div>
              </div>

              {expanded === story.id && (
                <div className="ark-storybank-detail">
                  {story.situation && <div><strong>Situation:</strong> {story.situation}</div>}
                  {story.task      && <div><strong>Task:</strong>      {story.task}</div>}
                  {story.action    && <div><strong>Action:</strong>    {story.action}</div>}
                  {story.result    && <div><strong>Result:</strong>    {story.result}</div>}
                  {story.reflection && <div><strong>Reflection:</strong> {story.reflection}</div>}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
